import React from "react";
import { Check, X } from "@phosphor-icons/react";

/**
 * LandingPricingTeaser — sezione prezzi inline sulla landing.
 *
 * iter v31 r51 — Tutti i riferimenti a brochure/volantino/PDF stampabili
 * RIMOSSI. Pronto NON produce brochure stampabili: lo strumento esiste
 * solo come modal interno, output non usabile in produzione.
 */
const PLANS = [
  {
    name: "Free",
    price: "0 €",
    cadence: "/mese · per sempre",
    // iter v33 r99g · Promo lancio: 60 crediti UNA TANTUM,
    // iter v33 r106 · Bump post-promo 5 → 10 crediti/mese Free.
    // Prima: 60 promo UNA TANTUM fino 30/09/2026, poi 10/mese.
    // NO "60 crediti/mese" (era rolling).
    tagline: "Per provare l'app con un immobile.",
    rows: [
      { yes: true,  text: "Promo lancio: 60 crediti inclusi per i nuovi iscritti." },
      { yes: true,  text: "Dal 1° ottobre: Free continua con 10 crediti/mese. I crediti promo non utilizzati restano disponibili." },
      { yes: true,  text: "1 immobile in archivio" },
      { yes: false, text: "Estensione Chrome per portali" },
      { yes: false, text: "Agenda vocale" },
      { yes: false, text: "Pacchetto social" },
      { yes: true,  text: "Watermark Pronto sui contenuti condivisi" },
    ],
  },
  {
    name: "Start",
    price: "29 €",
    cadence: "/mese · oppure 249 € l'anno (–28%)",
    tagline: "Per chi gestisce 1-2 immobili al mese.",
    rows: [
      { yes: true, text: "150 crediti al mese (foto, social, voce)" },
      { yes: true, text: "Fino a 5 immobili in archivio" },
      { yes: true, text: "Sopralluogo vocale (1 credito a sopralluogo)" },
      { yes: true, text: "Agenda vocale con sync Google e Apple Calendar" },
      { yes: true, text: "Estensione Chrome per Idealista e Immobiliare.it" },
      { yes: true, text: "Import XML dal gestionale" },
      { yes: true, text: "Pacchetto social: post, story, carosello" },
      { yes: true, text: "Watermark Pronto sui contenuti condivisi" },
    ],
  },
  {
    name: "Pro",
    price: "49 €",
    cadence: "/mese · oppure 399 € l'anno (–32%)",
    tagline: "Per chi lavora a tutti gli effetti.",
    highlight: true,
    rows: [
      { yes: true, text: "320 crediti al mese (foto, social, voce)" },
      { yes: true, text: "Immobili in archivio: illimitati" },
      { yes: true, text: "Sopralluogo vocale (1 credito a sopralluogo)" },
      { yes: true, text: "Niente watermark Pronto sui contenuti" },
      { yes: true, text: "Assistente Pronto illimitato · senza consumare crediti" },
      { yes: true, text: "Tutto lo Start incluso" },
    ],
  },
];

const Row = ({ yes, text }) => (
  <li className="flex items-start gap-2.5 text-[13px] text-[#1C1C1A] leading-snug py-1.5">
    {yes ? (
      <Check size={15} weight="bold" className="text-[#7C8B6E] shrink-0 mt-0.5" />
    ) : (
      <X size={15} weight="bold" className="text-[#B6B3AB] shrink-0 mt-0.5" />
    )}
    <span className={yes ? "" : "text-[#6B6A65]"}>{text}</span>
  </li>
);

export default function LandingPricingTeaser() {
  return (
    <section
      id="pricing"
      className="py-16 sm:py-24 lg:py-28 bg-white"
      data-testid="pricing-teaser"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 lg:px-10">
        <div className="text-center mb-12 sm:mb-14 max-w-2xl mx-auto">
          <span className="text-[11px] uppercase tracking-[0.22em] font-bold text-[#7C8B6E]">
            Prezzi
          </span>
          <h2 className="font-editorial text-[32px] sm:text-5xl lg:text-[56px] mt-3 leading-[1.0] tracking-tighter text-[#1C1C1A]">
            Tre piani.
            <br />
            <span className="italic text-[#7C8B6E]">Disdici quando vuoi.</span>
          </h2>
          <p className="mt-5 text-[14.5px] sm:text-[15.5px] text-[#3F3D38] leading-relaxed">
            Tutti i piani fatturati con fattura elettronica. Niente vincolo
            di durata. Su Free puoi restare per sempre, su Start e Pro
            disdici dal pannello in un click.
          </p>
        </div>

        <div
          className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6"
          data-testid="pricing-teaser-cards"
        >
          {PLANS.map((p) => (
            <div
              key={p.name}
              className={`relative bg-white border rounded-2xl p-7 sm:p-8 transition-shadow ${
                p.highlight
                  ? "border-[#7C8B6E] shadow-[0_16px_48px_-12px_rgba(124,139,110,0.32)]"
                  : "border-[#E5E7E0] hover:shadow-md"
              }`}
              data-testid={`pricing-card-${p.name.toLowerCase()}`}
            >
              {p.highlight && (
                <span className="absolute -top-3 left-7 px-2.5 py-1 bg-[#7C8B6E] text-white text-[10px] uppercase tracking-[0.22em] font-bold rounded-full">
                  Più scelto
                </span>
              )}
              <div className="font-editorial text-[26px] text-[#1C1C1A] mb-1">
                {p.name}
              </div>
              <div className="text-[12.5px] text-[#6B6A65] mb-5">{p.tagline}</div>
              <div className="flex items-baseline gap-1.5 mb-6">
                <span className="font-editorial text-[42px] text-[#1C1C1A] leading-none">
                  {p.price}
                </span>
                <span className="text-[12.5px] text-[#6B6A65]">{p.cadence}</span>
              </div>
              <ul className="space-y-0 divide-y divide-[#E5E7E0]/60">
                {p.rows.map((r, i) => (
                  <Row key={i} {...r} />
                ))}
              </ul>
            </div>
          ))}
        </div>

        <p className="mt-10 text-center text-[12.5px] text-[#6B6A65] max-w-2xl mx-auto">
          Ogni funzione utilizza un numero di crediti diverso. Trovi il dettaglio sulla pagina Prezzi e nel tuo saldo crediti dentro l&apos;app.
          <br />
          I 60 crediti gratis all&apos;iscrizione restano disponibili fino a esaurimento; il piano Free continua con 10 crediti al mese.
        </p>
      </div>
    </section>
  );
}
